import { makeAutoObservable, runInAction } from "mobx";

class CheckStore {
  data = {
    checkList: [], //{ label: "", checked: true }
    allChecked: false,
    isShowCheck: false
  }

  test = ""

  constructor() {
    makeAutoObservable(this)
  }

  setData(n) {
    if(!n) return
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }

  reset() {
    this.setData({
      checkList: [],
      allChecked: false,
      isShowCheck: false
    })
  }

  getChecked(label) {
    let ret = false
    if(label) {
      const target = this.data.checkList.find(item => item.label == label)
      ret = target?.checked || false
    } 
    return ret
  }

  setChecked(label, checked) {
    if(!label) return
    const target = this.data.checkList.find(item => item.label == label)
    if(!target) {
      this.data.checkList.push({
        label, checked
      })
    } else {
      target.checked = checked
    }
    this.setData({
      checkList: this.data.checkList
    })
  }
  setAllChecked(checked) {
    this.data.checkList.forEach(item => {
      item.checked = checked
    })
    this.setData({
      checkList: this.data.checkList
    })
  }
}

const checkStore = new CheckStore()

export default checkStore